<script setup>
import { inject } from 'vue';
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { ecriretailleFichier } from '@/scripts/global.js';

const modele = inject('modele');
const getImport = inject('getImport');

const visible = defineModel('visible', {
    type: Boolean
});

function ecrireImportDonnees(idImport) {
    const importDonnees = getImport(idImport);
    return `${importDonnees.libelle} (${importDonnees.nom})`;
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal>
            <template #header>
                <label class="titre">Sources de données</label>
            </template>
            <div class="corps-modale-sources-donnees" v-if="visible">
                <DataTable :value="modele.donnees.imports" paginator :rows="10" tableStyle="min-width: 50rem">
                    <Column field="idImport" header="Import" sortable>
                        <template #body="slotProps">
                            <label>{{ ecrireImportDonnees(slotProps.data.idImport) }}</label>
                        </template>                        
                    </Column>
                    <Column field="nomFichier" header="Nom du fichier" sortable></Column>
                    <Column field="tailleFichier" header="Taille du fichier" sortable>
                        <template #body="slotProps">
                            <label>{{ ecriretailleFichier(slotProps.data.tailleFichier) }}</label>
                        </template>                        
                    </Column>
                    <Column field="dateModifFichier" header="Date de dernière modification" sortable>
                        <template #body="slotProps">
                            <label>{{ (new Date(slotProps.data.dateModifFichier)).toLocaleString() }}</label>
                        </template>                        
                    </Column>
                    <Column field="nbValeursCourant" header="Nb. valeurs" sortable></Column>
                </DataTable>
            </div>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

</style>